export enum HealthAnalysisRecollectReason {
    IDENTITY_MISSING = 'IDENTITY_MISSING',
    EXCESS_OF_BIOLOGIC_MATERIAL = 'EXCESS_OF_BIOLOGIC_MATERIAL',
    EXTRAVASED_MATERIAL = 'EXTRAVASED_MATERIAL',
    INCORRECT_DATA = 'INCORRECT_DATA',
    EXPIRED_COLLECTOR_EXPIRATION_DATA = 'EXPIRED_COLLECTOR_EXPIRATION_DATA',
    EXPIRED_COLLECTOR_EXPIRATION_DATA_PRESCRIBER = 'EXPIRED_COLLECTOR_EXPIRATION_DATA_PRESCRIBER',
    LOW_QUALITY_PROCESSING_DATA = 'LOW_QUALITY_PROCESSING_DATA',
    OTHER_CAUSED_BY_USER = 'OTHER_CAUSED_BY_USER',
    OTHER_CAUSED_BY_CIERA = 'OTHER_CAUSED_BY_CIERA',
}
